import React, { useState } from 'react'
import './TweetBox.css'
import { Avatar, Button } from "@material-ui/core"
import db from '../firebase'
import firebase from 'firebase'

function TweetBox() {
  const [tweetMessage, setTweetMessage] = useState('')
  const [tweetImage, setTweetImage] = useState('')

  const sendTweet = e => {
    e.preventDefault();

    db.collection('posts').add({
      displayName: 'Bob',
      userName: 'Huntersgold',
      verified: true,
      text: tweetMessage,
      image: tweetImage,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      avatar: "https://avatars3.githubusercontent.com/u/4311248"
    })

    setTweetMessage("")
    setTweetImage("")
  }


  return (
    <div className="tweetBox">
      <form>
        <div className="tweetBox__input">
          <Avatar src="https://avatars3.githubusercontent.com/u/4311248"></Avatar>
          <input
            onChange={e => setTweetMessage(e.target.value)}
            value={tweetMessage}
            placeholder="What's happening"
            type="text"
          />
        </div>

        <input
          onChange={e => setTweetImage(e.target.value)}
          value={tweetImage}
          className="tweetBox__imageInput"
          placeholder="Optional: Enter image URL"
          type="text"
        />

        <Button className="tweetBox__tweetButton" onClick={sendTweet}>Tweet</Button>
      </form>

    </div>
  )
}

export default TweetBox
